<template>
    <div>
        <div class="bg-cover" style="background-image: url(/images/banner-bg.jpg)">
            <div class="container py-12">
                <h1 class="text-4xl uppercase font-light">Author Directory</h1>
            </div>
        </div>
        <div class="container mb-6">

            <Breadcrumbs :breadcrumbs="[
                {label: 'Home', href: '/'},
                {label: 'Authors', href: '/author-directory'},
            ]" class="my-6"/>

            <p class="text-sm mb-6">
                Below is a list of cardio-thoracic surgeons who have contributed to <i>MMCTS</i>. Please click through
                to see their profiles and links to their posts. If you would like to become an <i>MMCTS</i> author,
                please visit <a href="/page/431">Contributing to MMCTS.</a>
            </p>

            <div v-for="(group, letter) in authors" class="mb-6">
                <h2 class="mb-4 text-lg">{{ letter }}</h2>
                <ul class="space-y-1 sm:column-2 md:column-3 lg:column-4">
                    <li v-for="author in group">
                        <inertia-link :href="`/author/${author.id}`">
                            {{ author.last_name }}, {{ author.first_name }}
                        </inertia-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

import Layout from "@app/Shared/Components/Layout";
import Breadcrumbs from "@app/Shared/Components/Breadcrumbs";

export default {

    props: {
        authors: Object,
    },

    layout: Layout,

    components: {
        Breadcrumbs
    }
};

</script>
